import type { DocMigration } from "../docMigration";

// This list was generated by "yarn higharc gen prop-library validate" so that it covers the minimal set of materials referred to in the built-in prop library.
// It maps the material paths to prefixed material cache keys.
const migratedKeys = {
  "Color.C.SystemColors.Blue": "MATSRC_2__1",
  "Color.C.SystemColors.Gray70": "MATSRC_2__15",
  "Metal_Powder.C.MetalPowder_Colors.Bronze": "MATSRC_12__1982",
  "Metal_Screen.Default": "MATSRC_13__",
  "Paint_Gloss.C.SherwinWilliams.SW_6926_LuckyGreen": "MATSRC_16__1233",
  "Prop_BlackGlass.Default": "MATSRC_235__",
  "Tree_Bark_Generic.Default": "MATSRC_36__",
  "Tree_Foliage_Generic.Default": "MATSRC_37__",
};

function normalizePropMaterialOverrideKeys(props: { [key: string]: any }): any {
  for (const prop of Object.values(props)) {
    if (prop.materialOverrides) {
      const newMaterialOverrides = {};
      for (const materialKey of Object.keys(prop.materialOverrides)) {
        if (migratedKeys.hasOwnProperty(materialKey)) {
          newMaterialOverrides[migratedKeys[materialKey]] = prop.materialOverrides[materialKey];
        } else {
          newMaterialOverrides[materialKey] = prop.materialOverrides[materialKey];
        }
      }
      prop.materialOverrides = newMaterialOverrides;
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_505: DocMigration = {
  maxSchemaVersion: "0.0.505",
  description: "Normalize prop material override keys",
  apply(json: any): any {
    const { propAttributes = {}, propInstances = {} } = json;

    normalizePropMaterialOverrideKeys(propAttributes);
    normalizePropMaterialOverrideKeys(propInstances);

    json.propAttributes = propAttributes;
    json.propInstances = propInstances;

    return json;
  },
};

export default migration_0_0_505;
